import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssociationExitNoteService {

  private URL = environment.api + "api/erp/exit-notes/associations";

  constructor(
    private http: HttpClient
  ) { }

  generateAssociationSale(clientInvoiceId: number){
    return this.http.post(this.URL + `/associations-sale/${clientInvoiceId}`,{})
  }

  getAllAssociationExitNoteSale(){
    return this.http.get(this.URL + `/associations-sale/all`)
  }

  getAssociationExitNoteNull(){
    return this.http.get(this.URL + `/not-associations-sale`)
  }

  getAssociationExitNoteSale(startDate: any, endDate: any){
    return this.http.get(this.URL + `/associations-sale/dates/${startDate}/${endDate}`)
  }

  getAssociationSaleByExitNoteId(exitNoteId: number) {
    return this.http.get(this.URL + `/associations-sale/exit-notes/${exitNoteId}`);
  }

  assignExitNoteToAssociation(associationId: number, data: any){
    return this.http.put(this.URL + `/associations-sale/${associationId}`, data)
  }

  deleteExitNoteToAssociation(associationId: number){
    return this.http.get(this.URL + `/associations-sale/${associationId}`)
  }
}
